export default "A space horror puzzle game I made for Scream Jam 2023, a Halloween game jam.\n[itch.io](https://konlet.itch.io/leviathans-cry)\n"